import EvervaultSdkProvider from 'lib/forms/CreditCardForm/EvervaultSdkProvider'

function useEvervaultEnv() {
  return {
    // eslint-disable-next-line alternative/no-invalid-env-usage
    teamId: process.env.NEXT_PUBLIC_EVERVAULT_TEAM_ID as string,
    // eslint-disable-next-line alternative/no-invalid-env-usage
    appId: process.env.NEXT_PUBLIC_EVERVAULT_APP_ID as string
  }
}

export function EvervaultProvider({ children }: { children: React.ReactNode }) {
  const { teamId, appId } = useEvervaultEnv()

  return (
    <EvervaultSdkProvider teamId={teamId} appId={appId}>
      {children}
    </EvervaultSdkProvider>
  )
}
